import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const editExpenseItemQuery = (data) => {
  return axios.post(apiurl?.editExpenseItem, data);
};

const editExpenseItem = () => {
  const queryClient = useQueryClient();
  return useMutation(editExpenseItemQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getexpenseitemlist');
    }
  });
};

export default editExpenseItem;
